import React from 'react'
import { useIntl } from 'react-intl'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const { currentUser } = useAuth();
  
  return ( 
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='bi bi-speedometer2' // Updated icon for Dashboard
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      {currentUser?.permissions.find((item: any) => item.name === "view_health_cards") ? (
        <SidebarMenuItem
          to='/admin/health-cards/lists'
          icon='bi bi-heart-pulse' // Updated icon for Health Cards
          title={'Health Cards'}
          fontIcon='bi-app-indicator'
        />
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_reviews") ? (
        <SidebarMenuItem
          to='/admin/reviews/lists'
          icon='bi bi-chat-left-text' // Updated icon for Reviews
          title={'Reviews'}
          fontIcon='bi-app-indicator'
        />
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_seos") ? (
        <SidebarMenuItem
          to='/admin/seos/lists'
          icon='bi bi-search' // Updated icon for SEOs
          title={'Seos'}
          fontIcon='bi-app-indicator'
        />
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_seos") ? (
        <SidebarMenuItem
          to='/admin/areas/lists'
          icon='bi bi-geo-alt' // Updated icon for Areas
          title={'Areas'}
          fontIcon='bi-app-indicator'
        />
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_seos") ? (
        <SidebarMenuItem
          to='/admin/blogs/lists'
          icon='bi bi-journal-text' // Updated icon for Blogs
          title={'Blogs'}
          fontIcon='bi-app-indicator'
        />
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_coupons") ? (
        <SidebarMenuItem
          to='/admin/coupons/lists'
          icon='bi bi-tags' // Updated icon for Coupons
          title={'Coupons'}
          fontIcon='bi-app-indicator'
        />
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_faqs") ? (
        <SidebarMenuItem
          to='/admin/faqs/listing'
          icon='bi bi-question-circle' // Updated icon for FAQs
          title={'FAQS'}
          fontIcon='bi-app-indicator'
        />
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_cities") ? (
        <SidebarMenuItem
          to='/admin/cities'
          icon='bi bi-building' // Updated icon for Cities
          title={'Cities'}
          fontIcon='bi-app-indicator'
        />
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_manage_users") || currentUser?.permissions.find((item: any) => item.name === "view_permissions") ? (
        <SidebarMenuItemWithSub
          to='/crafted/pages'
          fontIcon='bi-archive'
          title='Users'
          icon='bi bi-people' // Updated icon for Users
        >
          {currentUser?.permissions.find((item: any) => item.name === "view_manage_users") ?
            <SidebarMenuItem to='admin/user-management/users' title='Manage Users' hasBullet={true} /> : null
          }
          {currentUser?.permissions.find((item: any) => item.name === "view_manage_users") ?
            <SidebarMenuItem to='admin/admin-management/admins' title='Manage Admin' hasBullet={true} /> : null
          }
          {currentUser?.permissions.find((item: any) => item.name === "view_manage_users") ?
            <SidebarMenuItem to='admin/garage-management/garages' title='Manage Garages' hasBullet={true} /> : null
          }
          {currentUser?.permissions.find((item: any) => item.name === "view_permissions") ?
            <SidebarMenuItem
              to='admin/user-management/permissions'
              title='Permissions'
              hasBullet={true}
            />
            : null}
        </SidebarMenuItemWithSub>
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_car_brand") || currentUser?.permissions.find((item: any) => item.name === "view_car_model") || currentUser?.permissions.find((item: any) => item.name === "view_car_varient") ? (
        <SidebarMenuItemWithSub
          to='/cars'
          fontIcon='bi-archive'
          title='Manage Cars'
          icon='bi bi-car-front' // Updated icon for Manage Cars
        >
          {currentUser?.permissions.find((item: any) => item.name === "view_car_brand") ?
            <SidebarMenuItem to='admin/cars/brands' title='Car Brand' hasBullet={true} /> : null
          }
          {currentUser?.permissions.find((item: any) => item.name === "view_car_brand") ?
            <SidebarMenuItem to='admin/cars/models' title='Car Model' hasBullet={true} /> : null
          }
        </SidebarMenuItemWithSub>
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_service_category") || currentUser?.permissions.find((item: any) => item.name === "view_service") ? (
        <SidebarMenuItemWithSub
          to='/service'
          icon='bi bi-tools' // Updated icon for Service
          fontIcon='bi-archive'
          title='Service'
        >
          {currentUser?.permissions.find((item: any) => item.name === "view_service_category") ?
            <SidebarMenuItem to='/admin/service-management/category' title='Service Category' hasBullet={true} /> : null
          }
          {currentUser?.permissions.find((item: any) => item.name === "view_service_category") ?
            <SidebarMenuItem to='/admin/service-management/blogcategory' title='Blogs Category' hasBullet={true} /> : null
          }
          {currentUser?.permissions.find((item: any) => item.name === "view_service_category") ?
            <SidebarMenuItem to='/admin/service-management/services' title='Service' hasBullet={true} /> : null
          }
        </SidebarMenuItemWithSub>
      ) : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_lead") || currentUser?.permissions.find((item: any) => item.name === "add_lead") ?
      <SidebarMenuItemWithSub
        to='/lead-management'
        icon='bi bi-person-check' // Updated icon for Leads
        fontIcon='bi-archive'
        title='Leads'
      >
         {currentUser?.permissions.find((item: any) => item.name === "view_lead") ?
        <SidebarMenuItem to='/admin/lead-management/leads' title='Leads Listing' hasBullet={true} /> : null }
         {currentUser?.permissions.find((item: any) => item.name === "add_lead") ? 
        <SidebarMenuItem to='/admin/lead-management/add-lead' title='Add Leads' hasBullet={true} /> : null }
      </SidebarMenuItemWithSub>
      : null}
      {currentUser?.permissions.find((item: any) => item.name === "view_orders") ?
      <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Orders'
        fontIcon='bi-archive'
        icon='bi bi-bag' // Updated icon for Orders
      >
        <SidebarMenuItem to='admin/manage-orders/orders' title='View orders' hasBullet={true} />
      </SidebarMenuItemWithSub>
      : null }
      {currentUser?.permissions.find((item: any) => item.name === "view_excel_import") ?
      <SidebarMenuItem
        to='/import-excel'
        icon='bi bi-file-earmark-excel' // Updated icon for Excel Import
        title='Excel Import'
        fontIcon='bi-app-indicator'
      /> : null }
      {currentUser?.permissions.find((item: any) => item.name === "view_percentage_calculations") ?
      <SidebarMenuItem
        to='/percentage-calculations'
        icon='bi bi-percent' // Updated icon for Percentage Calculations
        title='Percentage Calculations'
        fontIcon='bi-app-indicator'
      /> : null}
      {currentUser?.user_type === 'super_admin' ? (
        <SidebarMenuItem
          to='/admin/crafted/pages/contact'
          icon='bi bi-gear' // Updated icon for Test Page
          title='testpage'
          fontIcon='bi-app-indicator'
        />
      ) : null}
    </>
  )
}

export { SidebarMenuMain }
